module.exports = __webpack_public_path__ + "assets/img/next_date.82631a9d.svg";